/** A successful product action may invalidate a mounted read view. */
export const API_MUTATION_EVENT = 'nolos-data-changed'

export function announceMutation(
  url: string,
  method = 'GET',
  target: EventTarget | undefined = typeof window === 'undefined' ? undefined : window
) {
  if (
    url.startsWith('/api/') &&
    ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method.toUpperCase())
  ) {
    target?.dispatchEvent(new Event(API_MUTATION_EVENT))
  }
}
